//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpAlert',
  components: {
    DpIcon,
  },
  props: {
    type: { type: String, default: null },
    message: { type: String, default: '' },
    visible: { type: Boolean, required: false, default: true },
    icon: { type: String, default: '' },
    closeable: { type: Boolean, default: false },
    overlayed: { type: Boolean, default: false },
  },
  methods: {
    closeAlert() {
      this.$emit('close');
    },
  },
};
